<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="pt-2 amenities-form">
          <!--  GENERAL AMENITIES -->
          <b-row class="mt-2">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">General</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group
                id="gen-amen"
                breakpoint="lg"
                align="left"
                label
                class="checkboxes-holder vertical"
              >
                <b-col
                  md="12"
                  v-for="sub in amenitiesList"
                  :key="sub.value"
                  class="amenity-section"
                >
                  <b-form-checkbox :value="sub.value" v-model="selAmenities">{{sub.text}}</b-form-checkbox>
                  <p class="amenity-description">{{sub.description}}</p>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>

          <!--  WORK AMENITIES -->
          <b-row class="mt-2">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">Work</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group id="work-amen" breakpoint="lg" align="left" label>
                <b-col
                  md="12"
                  v-for="sub in workAmenitiesList"
                  :key="sub.value"
                  class="amenity-section"
                >
                  <b-form-checkbox :value="sub.value" v-model="selWorkAmenities">{{sub.text}}</b-form-checkbox>
                  <p class="amenity-description">{{sub.description}}</p>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>

          <!--  PROPERTY AMENITIES -->
          <b-row class="mt-2">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">Property</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group id="prop-amen" breakpoint="lg" align="left" label>
                <b-col
                  md="12"
                  v-for="sub in propretyAmenitiesList"
                  :key="sub.value"
                  class="amenity-section"
                >
                  <b-form-checkbox :value="sub.value" v-model="selPropertyAmenities">{{sub.text}}</b-form-checkbox>
                  <p class="amenity-description">{{sub.description}}</p>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>

          <!--  PARKING -->
          <b-row class="mt-2">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">Parking</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group id="park-amen" breakpoint="lg" align="left" label>
                <b-form-radio-group
                  md="10"
                  class="amenity-section"
                  id="parkingPaymentRadio"
                  v-model="selParkingPayment"
                  :options="parkingPaymentOptions"
                  name="radioOpenions"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-select
                v-model="selParkingPlacement"
                :options="parkingPlacement"
                style="width: 250px;"
              ></b-form-select>
            </b-col>
          </b-row>

          <!--  STOVE AMENITIES -->
          <b-row class="mt-4">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">Cooking Stove</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group id="stove-amen" breakpoint="lg" align="left" label>
                <b-col
                  md="12"
                  v-for="sub in stoveAmenitiesList"
                  :key="sub.value"
                  class="amenity-section"
                >
                  <b-form-checkbox :value="sub.value" v-model="selStoveAmenities">{{sub.text}}</b-form-checkbox>
                  <p class="amenity-description">{{sub.description}}</p>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>

          <!--  SAFETY AMENITIES -->
          <b-row class="mt-2">
            <b-col>
              <p style="font-size: 15px;text-align:left;font-weight:bold">Safety</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0">
              <b-form-group id="safe-amen" breakpoint="lg" align="left" label>
                <b-col
                  md="12"
                  v-for="sub in safetyAmenitiesList"
                  :key="sub.value"
                  class="amenity-section"
                >
                  <b-form-checkbox :value="sub.value" v-model="selSafetyAmenities">{{sub.text}}</b-form-checkbox>
                  <p class="amenity-description">{{sub.description}}</p>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
// import {
//   amenitiesTypeList,
//   workAmenities,
//   propertyAmenities,
//   safetyAmenities,
//   stoveAmenities,
//   amenitiesMap,
//   parkingPlacementList
// } from '../../lists.js'
const lists = require("@/lists.js");
export default {
  props: {
    selectedAmenities: {
      type: Array,
      required: false
    },
    selectedParkingPayment: {
      type: String,
      required: false
    },
    selectedParkingPlacement: {
      type: String,
      required: false
    },
    useStoreValuesForPrePopulation: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      selParkingPayment: "",
      selParkingPlacement: "",
      amenitiesList: lists.amenitiesTypeList,
      workAmenitiesList: lists.workAmenities,
      propretyAmenitiesList: lists.propertyAmenities,
      safetyAmenitiesList: lists.safetyAmenities,
      stoveAmenitiesList: lists.stoveAmenities,
      parkingPlacement: lists.parkingPlacementList,
      selAmenities: [],
      selWorkAmenities: [],
      selPropertyAmenities: [],
      selSafetyAmenities: [],
      selStoveAmenities: [],
      parkingPaymentOptions: [
        { text: "Paid", value: "paid" },
        { text: "Free", value: "free" }
      ]
    };
  },
  watch: {
    selAmenities: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selWorkAmenities: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selPropertyAmenities: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selSafetyAmenities: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selStoveAmenities: {
      deep: true,
      handler: function(val) {
        this.$emit("emitContentChanged");
      }
    },
    selParkingPayment: function(val) {
        this.$emit("emitContentChanged");
    },
    selParkingPlacement: function(val) {
        this.$emit("emitContentChanged");
    },
    selectedAmenities(newValue, oldValue) {
      this.divideAmenitiesToSections(newValue);
    },
    selectedParkingPayment(newValue, oldValue) {
      this.selParkingPayment = newValue;
    },
    selectedParkingPlacement(newValue, oldValue) {
      this.selParkingPlacement = newValue;
    }
  },
  created() {
    if (this.useStoreValuesForPrePopulation) {
      this.divideAmenitiesToSections(this.$store.getters.techDet.amenities);
      this.selParkingPayment = this.$store.getters.techDet.parking.payment;
      this.selParkingPlacement = this.$store.getters.techDet.parking.placement;
    }
  },
  methods: {
    getParkingPayment() {
      return this.selParkingPayment;
    },
    getParkingPlacement() {
      return this.selParkingPlacement;
    },
    getSelectedAmenities() {
      var amenities = this.selAmenities.concat(this.selWorkAmenities);
      var amenities2 = amenities.concat(this.selPropertyAmenities);
      let amenities3 = amenities2.concat(this.selSafetyAmenities);
      return amenities3.concat(this.selStoveAmenities);
    },
    divideAmenitiesToSections(amentities) {
      for (let amenity of amentities) {
        switch (lists.amenitiesMap[amenity]) {
          case "safety":
            this.selSafetyAmenities.push(amenity);
            break;
          case "prop":
            this.selPropertyAmenities.push(amenity);
            break;
          case "general":
            this.selAmenities.push(amenity);
            break;
          case "work":
            this.selWorkAmenities.push(amenity);
            break;
          case "stove":
            this.selStoveAmenities.push(amenity);
            break;
        }
      }
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
.amenities-container {
  max-height: 628px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.amenities-container label {
  margin-bottom: 5px;
  border-radius: 10px;
}
.amenity-section {
  padding: 5px;
}

.amenity-description {
  color: grey;
  font-size: 15px;
  margin-top: 1em;
  font-style: italic;
}

.amenities-form {
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/listingComponents/listingAmenities.vue